const deJSON = {
  Tokyo: 'Muraqabah Pilgrimage portal',
  'Accent Sidebar': 'Akzent Seitenleiste',
  'Tokyo White React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  'Tokyo React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  'Tokyo Black React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  '&copy; 2026 - Muraqabah Pilgrimage portal':
    '&copy; 2026 - Muraqabah Pilgrimage portal',
  'Muraqabah Pilgrimage portal': 'Muraqabah Pilgrimage portal',
  Dashboards: 'Dashboards',
  Dashboard: 'Dashboard',
  General: 'Allgemein',
  Roles: 'Rollen',
  'Vendor Management': 'Lieferantenverwaltung',
  Vendors: 'Lieferanten',
  Package: 'Paket',
  Packages: 'Pakete',
  Master: 'Master',
  'Master Data': 'Stammdaten',
  Master_Data_type: 'Stammdatentyp ist erforderlich',
  Inquiry: 'Anfrage',
  'Inquiry Management': 'Anfragenverwaltung',
  Inquiries: 'Anfragen',
  'Service Management': 'Dienstleistungsmanagement',
  'Business Profile': 'Unternehmensprofil',
  your_analytics: 'Dies sind Ihre Analysestatistiken für heute',
  Search_by_name: 'Suche nach Name, Kurzcode oder Beschreibung...',
  Welcome: 'Willkommen',
  'Active Referrals': 'Aktive Empfehlungen',
  'See referring domains': 'Sehen Sie verweisende Domains',
  'which sent most traffic': 'die den meisten Traffic gesendet haben',
  'Pending Invitations': 'Ausstehende Einladungen',
  'Not opened yet': 'Noch nicht geöffnet',
  'See all invitations': 'Alle Einladungen anzeigen',
  'Sessions by Country': 'Sitzungen nach Land',
  'Bounce Rate': 'Absprungrate',
  'See all links': 'Alle Links anzeigen',
  'with high bounce rate.': 'mit hoher Absprungrate.',
  Conversion: 'Konversion',
  'with the best conversion rates.': 'mit den besten Konversionsraten.',
  'See products': 'Produkte anzeigen',
  'Audience Overview': 'Zielgruppenübersicht',
  Today: 'Heute',
  Yesterday: 'Gestern',
  'Last month': 'Letzter Monat',
  'Last year': 'Letztes Jahr',
  Users: 'Benutzer',
  'New users': 'Neue Benutzer',
  'Page views': 'Seitenaufrufe',
  'Avg. session duration': 'Durchschnittliche Sitzungsdauer',
  Sessions: 'Sitzungen',
  Conversions: 'Konversionen',
  'Sales Today': 'Verkäufe heute',
  'Customers per month': 'Kunden pro Monat',
  'Earnings Report': 'Einnahmenbericht',
  'Top Landing Pages': 'Top-Landing-Pages',
  Impressions: 'Impressionen',
  Clicks: 'Klicks',
  'Visit URL': 'URL besuchen',
  'Traffic Sources': 'Verkehrsquellen',
  'Generate Chart': 'Diagramm generieren',
  'pages/session': 'Seiten/Sitzung',
  'New Sessions': 'Neue Sitzungen',
  'User & Role Management': 'Benutzer- & Rollenverwaltung',
  Management: 'Verwaltung',
  user_can_be_managed:
    'Alle Aspekte, die den Benutzer betreffen, können von dieser Seite aus verwaltet werden',
  Add: 'Hinzufügen',
  role_can_be_managed:
    'Alle Aspekte, die die Rolle betreffen, können von dieser Seite aus verwaltet werden',
  Role_required: 'Rollenname ist erforderlich',
  'Add new role': 'Neue Rolle hinzufügen',
  'Edit role details': 'Rolenetails bearbeiten',
  fields_new_role:
    'Füllen Sie die untenstehenden Felder aus, um eine neue Rolle hinzuzufügen.',
  'Role Name': 'Rollenname',
  'Short Code': 'Kurzcode',
  Description: 'Beschreibung',
  Cancel: 'Abbrechen',
  Save: 'Speichern',
  Edit: 'Bearbeiten',
  Url: 'URL',
  Delete: 'Löschen',
  'Tour Itinerary': 'Reiseplan',
  below_to_edit:
    'Füllen Sie die untenstehenden Felder aus, um die Rollendetails zu bearbeiten.',
  Description_required: 'Beschreibung erforderlich',
  Short_Code_required: 'Kurzcode erforderlich',
  Special_Chars_not_allowed: 'Sonderzeichen & Zahlen sind nicht erlaubt.',
  'Search by name, shortcode or description...':
    'Suche nach Name, Kurzcode oder Beschreibung...',
  'Sr. No.': 'Sr. No.',
  Name: 'Name',
  Shortcode: 'Kurzcode',
  'Created By': 'Erstellt von',
  'Modified By': 'Geändert von',
  Actions: 'Aktionen',
  'Loading...': 'Lädt...',
  'No results found': 'Keine Ergebnisse gefunden',
  'Advanced View': 'Erweiterte Ansicht',
  'Assigned Roles': 'Zugewiesene Rollen',
  Password: 'Passwort',
  Email: 'E-Mail',
  'Last name': 'Nachname',
  'First name': 'Vorname',
  Airlines: 'Fluggesellschaften',
  'Select room sharing': 'Zimmeraufteilung auswählen',
  'Room Sharing': 'Zimmeraufteilung',
  'Package Type': 'Pakettyp',
  'Select package type': 'Pakettyp auswählen',
  'Package Details': 'Paketdetails',
  'Package Name': 'Paketname',
  Departure: 'Abfahrt',
  'Package Room Sharing': 'Paketzimmeraufteilung',
  'Package Airline': 'Paketfluggesellschaft',
  'Package Amount': 'Paketbetrag',
  'Package Inquiry Date': 'Paketanfragendatum',
  'Inquiry Date': 'Anfragendatum',
  'Vendor Name': 'Lieferantenname',
  'Phone Number': 'Telefonnummer',
  'Customer Email': 'Kunden-E-Mail',
  'Customer Name': 'Kundenname',
  Status: 'Status',
  'Customer Phone No.': 'Kunden-Telefonnummer',
  'Customer Phone Number': 'Kunden-Telefonnummer',
  Search_by_customer_name:
    'Suche nach Kundenname, E-Mail, Telefonnummer, Pakettyp, Name, Zimmeraufteilung...',
  'Status Type': 'Statusart',
  'Select status type': 'Statusart auswählen',
  'NEW LEAD': 'NEUE LEITUNG',
  'FOLLOW UP': 'NACHFOLGEN',
  CLOSED: 'GESCHLOSSEN',
  'NOT INTERESTED': 'NICHT INTERESSIERT',
  'NOT CONTACTED': 'NICHT KONTAKTIERT',
  'Room Sharing is required': 'Zimmeraufteilung ist erforderlich',
  PACKAGE_TYPE: 'PAKET TYP',
  AIRLINES_TYPE: 'FLUGGESELLSCHAFTEN TYP',
  ROOM_SHARING: 'ZIMMERTEILUNG',
  INCLUSION_TYPE: 'EINSCHLUSS TYP',
  EXCLUSION_TYPE: 'AUSSCHLUSS TYP',
  An_error_occurred: 'Ein Fehler ist beim Erstellen der Stammdaten aufgetreten',
  Master_Type: 'Stammdaten Typ',
  'Select master data type': 'Stammdaten Typ auswählen',
  Update: 'Aktualisieren',
  'End Date': 'Enddatum',
  Search_by_master_data: 'Nach Namen suchen...',
  Inclusions_and_Package: 'Einschlüsse_und_Paket',
  Exclusions: 'Ausschlüsse',
  'Upload Images': 'Bilder hochladen',
  Days: 'Tage',
  'Search by customer name, email,phone no,package name,vendor name...':
    'Nach Kundenname, E-Mail, Telefonnummer, Paketname, Lieferantenname suchen...',
  'Search by customer name, email,phone no,package name':
    'Nach Kundenname, E-Mail, Telefonnummer, Paketname suchen',
  'From Date': 'Von Datum',
  'To Date': 'Bis Datum',
  ID: 'ID',
  Search: 'Suche',
  'Customer Lead': 'Kundenführung',
  'Vendor Lead': 'Lieferantenführung',
  'Search by vendor name': 'Nach Lieferantenname suchen...',
  'Customer Lead Details': 'Details zur Kundenführung',
  'Vendor Lead Details': 'Details zur Lieferantenführung',
  'Vendor List': 'Lieferantenliste',
  'Lead Count': 'Lead-Anzahl',
  'Package Lead Count': 'Paket-Lead-Anzahl',
  'Search by name or email...': 'Nach Namen oder E-Mail suchen...',
  'Search by business name, mobile number, email or registered at...':
    'Nach Geschäftsname, Handynummer, E-Mail oder Registrierungsdatum suchen...',
  'Search by description': 'Nach Beschreibung suchen',
  'In-Active': 'Inaktiv',
  'The url field is required': 'Das URL-Feld ist erforderlich',
  'The description field is required': 'Das Beschreibungsfeld ist erforderlich',
  'The position field is required': 'Das Positions Feld ist erforderlich',
  'Business Information': 'Unternehmensinformationen',
  'Mobile Number': 'Handynummer',
  'Email ID': 'E-Mail-ID',
  'Complete Your Profile': 'Vervollständigen Sie Ihr Profil',
  Back: 'Zurück',
  'Complete Now': 'Jetzt vervollständigen',
  'Complete Your Profile in Just a Few Easy Steps!':
    'Vervollständigen Sie Ihr Profil in nur wenigen einfachen Schritten!',
  'Search by customer name or email...':
    'Nach Kundenname oder E-Mail suchen...',
  'Search by package name...': 'Nach Paketname suchen...',
  'Search by package name, package type or room sharing...':
    'Nach Paketname, Pakettyp oder Zimmeraufteilung suchen...',
  'Hajj/Umrah Package': 'Hajj/Umrah-Paket',
  'Customer Details': 'Kundendetails',
  'Package Lead': 'Paketführung',
  'The Mobile No field is required':
    'Das Feld für die Mobilnummer ist erforderlich',
  'The username field is required': 'Das Benutzername-Feld ist erforderlich',
  'The email provided should be a valid email address':
    'Die bereitgestellte E-Mail sollte eine gültige E-Mail-Adresse sein',
  'The email field is required': 'Das E-Mail-Feld ist erforderlich',
  'The role field is required': 'Das Rollenfeld ist erforderlich',
  'User Name': 'Benutzername',
  'Email address': 'E-Mail-Adresse',
  'Edit Bottom  Banner': 'Unteren Banner bearbeiten',
  'Upload image': 'Foto hochladen',
  'Bottom Banner Position': 'Position des unteren Banners',
  'The top banner created successfully':
    'Der obere Banner wurde erfolgreich erstellt',
  'The banner has been updated': 'Der Banner wurde aktualisiert',
  'Please upload an image': 'Bitte laden Sie ein Bild hoch',
  'Top Banner Position': 'Position des oberen Banners',
  "Couldn't update Position": 'Position konnte nicht aktualisiert werden',
  'Position has been updated': 'Position wurde aktualisiert',
  'Bottom Banner': 'Unterer Banner',
  Position: 'Position',
  'The bottom banner status has been updated':
    'Der Status des unteren Banners wurde aktualisiert',
  "Couldn't update bottom banner status":
    'Status des unteren Banners konnte nicht aktualisiert werden',
  'The role account created successfully':
    'Das Rollenkonto wurde erfolgreich erstellt',
  'Package Detail has been updated': 'Paketdetails wurden aktualisiert',
  'Error while saving package detail': 'Fehler beim Speichern der Paketdetails',
  'Package detail saved successfully': 'Paketdetails erfolgreich gespeichert',
  'Package Details approved successfully': 'Paketdetails erfolgreich genehmigt',
  'Error while approving Package Details':
    'Fehler bei der Genehmigung der Paketdetails',
  'Hotel Details approved successfully': 'Hoteldetails erfolgreich genehmigt',
  'Error while approving Hotel Details':
    'Fehler bei der Genehmigung der Hoteldetails',
  'Tour Itinerary approved successfully': 'Tourplan erfolgreich genehmigt',
  'Error while approving Tour Itinerary':
    'Fehler bei der Genehmigung des Tourplans',
  'Error while approving Inclusions':
    'Fehler bei der Genehmigung von Einschlüssen',
  'Inclusions approved successfully': 'Einschlüsse erfolgreich genehmigt',
  'Exclusions approved successfully': 'Ausschlüsse erfolgreich genehmigt',
  'Error while approving Exclusions':
    'Fehler bei der Genehmigung von Ausschlüssen',
  'Comment Added Successfully': 'Kommentar erfolgreich hinzugefügt',
  'The days are not specific to the provider dates':
    'Die Tage sind nicht spezifisch für die Anbieterdaten',
  'Row saved successfully': 'Zeile erfolgreich gespeichert',
  'Row updated successfully': 'Zeile erfolgreich aktualisiert',
  'Row deleted successfully': 'Zeile erfolgreich gelöscht',
  'Row Saved Successfully': 'Zeile erfolgreich gespeichert',
  'Row has been updated': 'Zeile wurde aktualisiert',
  'Row Deleted Successfully': 'Zeile erfolgreich gelöscht',
  'An error occurred while creating the role':
    'Beim Erstellen der Rolle ist ein Fehler aufgetreten',
  'Record has been updated': 'Datensatz wurde aktualisiert',
  'Error while updating record': 'Fehler beim Aktualisieren des Datensatzes',
  'Remark has been saved successfully': 'Bemerkung erfolgreich gespeichert',
  'Error while saving remark': 'Fehler beim Speichern der Bemerkung',
  'Permissions has been updated': 'Berechtigungen wurden aktualisiert',
  'Package status has been updated': 'Paketstatus wurde aktualisiert',
  "Couldn't update package status":
    'Paketstatus konnte nicht aktualisiert werden',
  'Password successfully changed': 'Passwort erfolgreich geändert',
  'Image size is too large': 'Bildgröße ist zu groß',
  'The bottom banner created successfully':
    'Der untere Banner wurde erfolgreich erstellt',
  'The banner was updated successfully':
    'Der Banner wurde erfolgreich aktualisiert',
  'Role status has been updated': 'Rollenstatus wurde aktualisiert',
  "Couldn't update role status":
    'Rollenstatus konnte nicht aktualisiert werden',
  'The user account created successfully':
    'Das Benutzerkonto wurde erfolgreich erstellt',
  'User status has been updated': 'Benutzerstatus wurde aktualisiert',
  "Couldn't update user status":
    'Benutzerstatus konnte nicht aktualisiert werden',
  'The card has been removed successfully':
    'Die Karte wurde erfolgreich entfernt',
  'The master data added successfully':
    'Die Stammdaten wurden erfolgreich hinzugefügt',
  'The master data has been updated': 'Die Stammdaten wurden aktualisiert',
  'Master data status has been updated':
    'Status der Stammdaten wurde aktualisiert',
  "Couldn't update master data status":
    'Status der Stammdaten konnte nicht aktualisiert werden',
  'Vendor details approved successfully':
    'Anbieterdetails wurden erfolgreich genehmigt',
  'Error while approving vendor details':
    'Fehler bei der Genehmigung von Anbieterdetails',
  'Comment added successfully': 'Kommentar erfolgreich hinzugefügt',
  'Business Information updated successfully':
    'Geschäftsinformationen erfolgreich aktualisiert',
  'Error while updating Business Information':
    'Fehler bei der Aktualisierung der Geschäftsinformationen',
  'Documents updated successfully': 'Dokumente erfolgreich aktualisiert',
  'Error while updating Documents':
    'Fehler bei der Aktualisierung der Dokumente',
  'Types of Tour updated successfully':
    'Arten von Touren erfolgreich aktualisiert',
  'Error while updating Types of Tour':
    'Fehler bei der Aktualisierung der Tourarten',
  'Payment Mode updated successfully': 'Zahlungsart erfolgreich aktualisiert',
  'Error while updating Payment Mode':
    'Fehler bei der Aktualisierung der Zahlungsart',
  'File uploaded successfully': 'Datei erfolgreich hochgeladen',
  'Error while uploading file': 'Fehler beim Hochladen der Datei',
  'File deleted successfully': 'Datei erfolgreich gelöscht',
  'Error while deleting file': 'Fehler beim Löschen der Datei',
  'Package rejected successfully': 'Paket erfolgreich abgelehnt',
  'An error occurred while rejecting package':
    'Beim Ablehnen des Pakets ist ein Fehler aufgetreten',
  'Add Reason for Rejection': 'Grund für Ablehnung hinzufügen',
  'The Vendor account created successfully':
    'Das Anbieterkonto wurde erfolgreich erstellt',
  'The user account has been updated': 'Das Benutzerkonto wurde aktualisiert',
  'Vendor status has been updated': 'Anbieterstatus wurde aktualisiert',
  'Could not update vendor status':
    'Anbieterstatus konnte nicht aktualisiert werden',
  'Password has been successfully sent to you email':
    'Passwort wurde erfolgreich an Ihre E-Mail gesendet',
  'Total Package Count': 'Gesamtzahl der Pakete',
  'Total Lead Count': 'Gesamtzahl der Leads',
  Active: 'Aktiv',
  Inactive: 'Inaktiv',
  'Lead Management': 'Lead-Management',
  Lead: 'Lead',
  'Are you sure you want to Activate this package?':
    'Möchten Sie dieses Paket wirklich aktivieren?',
  'Are you sure you want to In-Activate this package?':
    'Möchten Sie dieses Paket wirklich deaktivieren?',
  Activate: 'Aktivieren',
  'In-Activate': 'Deaktivieren',
  'Are you sure you want to Activate this banner?':
    'Möchten Sie diesen Banner wirklich aktivieren?',
  'Are you sure you want to In-Activate this banner?':
    'Möchten Sie diesen Banner wirklich deaktivieren?',
  'Are you sure you want to In-Activate this role?':
    'Möchten Sie diese Rolle wirklich deaktivieren?',
  'Are you sure you want to Activate this role?':
    'Möchten Sie diese Rolle wirklich aktivieren?',
  'Are you sure you want to In-Activate this user?':
    'Möchten Sie diesen Benutzer wirklich deaktivieren?',
  'Are you sure you want to In-Activate this master data?':
    'Möchten Sie diese Stammdaten wirklich deaktivieren?',
  'Are you sure you want to Activate this master data?':
    'Möchten Sie diese Stammdaten wirklich aktivieren?',
  'Are you sure you want to In-Activate this vendor?':
    'Möchten Sie diesen Anbieter wirklich deaktivieren?',
  'Are you sure you want to Activate this vendor?':
    'Möchten Sie diesen Anbieter wirklich aktivieren?',
  'Banner Management': 'Banner-Verwaltung',
  Banner: 'Banner',
  'Banner Top': 'Banner oben',
  'Banner Bottom': 'Banner unten',
  'Type of Tours Provided': 'Art der angebotenen Touren',
  Haj: 'Hadj',
  Umrah: 'Umra',
  Ziyarat: 'Ziyarat',
  Pincode: 'Postleitzahl',
  Country: 'Land',
  State: 'Bundesland',
  'Select City': 'Stadt auswählen',
  Landmark: 'Sehenswürdigkeit',
  Area: 'Bereich',
  'Unit, Block, Wing, Building Name': 'Einheit, Block, Flügel, Gebäudename',
  'Street Name': 'Straßenname',
  Address: 'Adresse',
  'Business Description': 'Unternehmensbeschreibung',
  'Uploading...': 'Hochladen...',
  'Upload Company Logo': 'Firmenlogo hochladen',
  'Company Logo': 'Firmenlogo',
  'Email Address': 'E-Mail-Adresse',
  'Year of Establishment': 'Gründungsjahr',
  'Business Name': 'Unternehmensname',
  'Account & Business Information': 'Konto- & Unternehmensinformationen',
  Cheque: 'Scheck',
  'Credit Card': 'Kreditkarte',
  'Debit Card': 'Debitkarte',
  Cash: 'Bar',
  UPI: 'UPI',
  'Online Booking': 'Online-Buchung',
  'Demand Draft': 'Nachfrageentwurf',
  'Payment Mode': 'Zahlungsart',
  'Member/Accredited/Authorised': 'Mitglied/Akkreditiert/Berechtigt',
  'IATA License': 'IATA-Lizenz',
  'Upload IATA License': 'IATA-Lizenz hochladen',
  'Ministry of Tourism (GOI)': 'Ministerium für Tourismus (GOI)',
  'Allowed *.jpeg, *.jpg, *.png, *.pdf':
    'Erlaubt *.jpeg, *.jpg, *.png, *.pdf',
  'Upload Ministry of Tourism (GOI)':
    'Ministerium für Tourismus (GOI) hochladen',
  HGO: 'HGO',
  'Upload HGO': 'HGO hochladen',
  PAN: 'PAN',
  'Upload PAN': 'PAN hochladen',
  'Business PAN': 'Unternehmens-PAN',
  'Upload Business PAN': 'Unternehmens-PAN hochladen',
  'GST Number': 'GST-Nummer',
  'Upload GST Certificate': 'GST-Zertifikat hochladen',
  'GST Certificate': 'GST-Zertifikat',
  'Package Name is required': 'Paketname ist erforderlich',
  'Package Type is required': 'Pakettyp ist erforderlich',
  'Number of days is required': 'Anzahl der Tage ist erforderlich',
  'Number of days must be a positive number':
    'Anzahl der Tage muss eine positive Zahl sein',
  'Number of days must be an integer':
    'Anzahl der Tage muss eine Ganzzahl sein',
  'Room sharing is required': 'Zimmeraufteilung ist erforderlich',
  'Airline is required': 'Fluggesellschaft ist erforderlich',
  'Departure date is required': 'Abreisedatum ist erforderlich',
  'Return Date is required': 'Rückreisedatum ist erforderlich',
  'City is required': 'Stadt ist erforderlich',
  'Pricing is required': 'Preisangabe ist erforderlich',
  'Pricing must be a positive number': 'Preis muss eine positive Zahl sein',
  'The password field is required': 'Das Passwortfeld ist erforderlich',
  'IATA License is required': 'IATA-Lizenz ist erforderlich',
  'File Size is too large': 'Dateigröße ist zu groß',
  'Ministry of Tourism is required':
    'Ministerium für Tourismus ist erforderlich',
  'HGO is required': 'HGO ist erforderlich',
  'PAN is required': 'PAN ist erforderlich',
  'Pan Card number is not valid': 'Pan-Kartennummer ist ungültig',
  'Business PAN is required': 'Unternehmens-PAN ist erforderlich',
  'Business Pan Card number is not valid':
    'Unternehmens-Pan-Kartennummer ist ungültig',
  'GST number is not valid': 'GST-Nummer ist ungültig',
  'Pan Document is required': 'Pan-Dokument ist erforderlich',
  'Business Pan Document is required':
    'Unternehmens-Pan-Dokument ist erforderlich',
  'GST Certificate Document is required':
    'GST-Zertifikatsdokument ist erforderlich',
  'Unsupported Format': 'Nicht unterstütztes Format',
  'Registered At': 'Registriert bei',
  ALL: 'ALLE',
  PENDING: 'AUSSTEHEND',
  INPROCESS: 'IN BEARBEITUNG',
  COMPLETED: 'ABGESCHLOSSEN',
  REJECTED: 'ABGELEHNT',
  'Select city': 'Stadt auswählen',
  Return: 'Rückkehr',
  'Hotel Details': 'Hotel Details',
  Distance: 'Entfernung',
  Location: 'Ort',
  'Inclusions and Package Highlights': 'Inklusionen und Paket-Highlights',
  Username: 'Benutzername',
  'The admin will review your profile, and approval will be granted once the review process is complete.':
    'Der Administrator wird Ihr Profil überprüfen, und die Genehmigung wird erteilt, sobald der Überprüfungsprozess abgeschlossen ist.'
};

export default deJSON;
